<template>
  <div>
    <h1 id="formTitle">Enter marriage details</h1>
    <ValidationObserver ref="form" v-slot="{ errors, valid }">
      <!-- using an anchor to scroll to since jQuery doesn't work the first time with a hidden element -->
      <ValidationErrors
        :class="{ hidden: !showErrors || valid }"
        :errors="errors"
      />
      <form @submit="submitForm" id="submitForm">
        <li class="section">
          <fieldset>
            <legend>
              Use this form to generate the Notice of Intended Marriage document
              that is required to be lodged with the Brisbane registry no less
              than 1 month before your ceremony.
            </legend>
          </fieldset>
        </li>
        <PersonDetails number="1" v-model="details.personDetails[0]" />
        <PersonDetails number="2" v-model="details.personDetails[1]" @copyAddress="copyAddress"/>
        <RelationshipDetails v-model="details.relationshipDetails" />
        <ContactDetails v-model="details.contactDetails"/>
        <PrivacyNotice />
        <li id="inProgress">
          <p v-if="inProgress">Submitting your enquiry...</p>
          <p v-else></p>
        </li>
        <li>
          <fieldset>
            <ul class="actions">
              <li>
                <strong>
                  <button id="submitButton" :disabled="inProgress">Submit form</button>
                </strong>
              </li>
            </ul>
          </fieldset>
        </li>
      </form>
    </ValidationObserver>
    <hr />
  </div>
</template>

<script>
import sppapi from "@/sppapi.js";
import PrivacyNotice from "./TheMarriagePrivacyNotice.vue";
import PersonDetails from "./PersonDetails.vue";
import RelationshipDetails from "./RelationshipDetails.vue";
import ContactDetails from "./ContactDetails.vue"
import ValidationErrors from "../ValidationErrors.vue";

export default {
  methods: {
    copyAddress(value) {
      let isSame = value;
      console.log('here ' + value)
      if (isSame) {
        console.log(this.details)
        this.details.personDetails[1].addressDetails = this.details.personDetails[0].addressDetails;
      }
      else {
        this.details.personDetails[1].addressDetails = this.newPersonDetails().addressDetails;
      }
    },
    newParentDetails() {
      return {
        givennames: "",
        surname: "",
        birthGivenNames: "",
        birthSurname: "",
        countryOfBirth: "",
      }
    },
    newPersonDetails() {
      return {
        occupation: "",
        occupationOther: "",
        givennames: "",
        surname: "",
        description: "",
        dateOfBirth: "",
        sex: "",
        birthSuburbTown: "",
        birthState: "",
        birthCountry: "",
        addressDetails: {
          residenceLine1: "",
          residenceSuburb: "",
          residenceState: "",
          residencePostcode: "",
          residenceCountry: "Australia",
        },
        conjugalDetails: {
          conjugalStatus: "",
          previousMarriageTerminated: "",
          previousMarriageTerminatedDate: "",
          courtMarriageEnded: "",
        },
        parentDetails: [
          this.newParentDetails(),
          this.newParentDetails(),
        ]
      }
    },
    flatten(ob) {
      var toReturn = {};

      for (var i in ob) {
          if (!Object.prototype.hasOwnProperty.call(ob, i)) continue;

          if ((typeof ob[i]) == 'object' && ob[i] !== null) {
              var flatObject = this.flatten(ob[i]);
              for (var x in flatObject) {
                  if (!Object.prototype.hasOwnProperty.call(flatObject, x)) continue;

                  toReturn[x] = flatObject[x];
              }
          } else {
              toReturn[i] = ob[i];
          }
      }
      return toReturn;
    },
    mapPersonParentDetails(details) {
      let flatParentDetails = {}
      flatParentDetails.motherGivennames = details.parentDetails[1].givennames;
      flatParentDetails.motherMaidenSurname = details.parentDetails[1].surname;
      flatParentDetails.motherBirthGivennames = details.parentDetails[1].birthGivenNames;
      flatParentDetails.motherBirthSurname = details.parentDetails[1].birthSurname;
      flatParentDetails.motherCountryOfBirth = details.parentDetails[1].countryOfBirth;
      flatParentDetails.fatherGivennames = details.parentDetails[0].givennames;
      flatParentDetails.fatherSurname = details.parentDetails[0].surname;
      flatParentDetails.fatherBirthGivennames = details.parentDetails[0].birthGivenNames;
      flatParentDetails.fatherBirthSurname = details.parentDetails[0].birthSurname;
      flatParentDetails.fatherCountryOfBirth = details.parentDetails[0].countryOfBirth;
      details.parentDetails = flatParentDetails;
    },
    mapAndFlattenDetails() {
      let mappedDetails = {};
      for (let i = 0; i < 2; i++) {
        let partyPrefix = "";
        switch (i) {
          case 0: 
            partyPrefix = "partyOne"
            break;
          case 1:
            partyPrefix = "partyTwo";
            break;
        }
        // clone the object to avoid references
        let details = JSON.parse(JSON.stringify(this.details.personDetails[i]));
        this.mapPersonParentDetails(details);

        for (let obj in details) {
          if (!Object.prototype.hasOwnProperty.call(details, obj)) continue;

          if ((typeof details[obj]) == 'object' && details[obj] !== null) {
            let flatObject = this.flatten(details[obj]);
            let flatDetails = {};
            for (let prop in flatObject) {
              if (Object.prototype.hasOwnProperty.call(flatObject, prop)) {
                  flatDetails[`${partyPrefix}${prop.charAt(0).toUpperCase() + prop.slice(1)}`] = 
                    flatObject[prop]
              }
            }
            mappedDetails = {...mappedDetails, ...flatDetails};
          }
          else if (typeof details[obj] == 'string') {
            mappedDetails[`${partyPrefix}${obj.charAt(0).toUpperCase() + obj.slice(1)}`] = 
                    details[obj];
          }
        }
      }
      mappedDetails = {...mappedDetails, ...this.flatten(this.details.relationshipDetails)};
      mappedDetails = {...mappedDetails, ...this.flatten(this.details.contactDetails)};
      // add default fields so we can pass validation for existing process in portal
      mappedDetails.ritesPerformed = "";
      mappedDetails.saveForLater = "true";
      mappedDetails.celebrantPlace = "";
      mappedDetails.related = this.details.relationshipDetails.partiesRelated;
      mappedDetails.partyOneDateOfBirth = this.convertDateFormat(mappedDetails.partyOneDateOfBirth);
      mappedDetails.partyTwoDateOfBirth = this.convertDateFormat(mappedDetails.partyTwoDateOfBirth);

      return mappedDetails;
    },
    submitForm: function(event) {
      event.preventDefault();
      this.$refs.form.validate().then((success) => {
        if (!success) {
          let el = document.getElementById("formTitle");
          el.scrollIntoView({ behavior: "smooth" });
          this.showErrors = true;
          return;
        } else {
          this.form = this.mapAndFlattenDetails(this.details);
          console.log(this);
          sppapi.startProcessAndCompleteTask(this);
        }
      });
    },
    convertDateFormat(date) { 
      // convert date from yyyy-mm-dd to dd/mm/yyyy
      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
    }
  },
  data() {
    return {
      inProgress: false,
      showErrors: false,
      processId: 'registerMarriageInt2',
      form: {},
      details: {
        personDetails: [
          this.newPersonDetails(),
          this.newPersonDetails()
        ],
        relationshipDetails: {
          partiesRelated: "false",
          relationship: "",
        },
        contactDetails: {
          partyOneEmail: "",
          partyOneMobile: "",
          partyTwoEmail: "",
          partyTwoMobile: ""
        },
      },
    };
  },
  components: {
    PrivacyNotice,
    PersonDetails,
    RelationshipDetails,
    ContactDetails,
    ValidationErrors
  }
};
</script>

<style scoped lang="scss">
.hidden {
  display: none;
}
</style>
